/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Body_Assessment_Taken_OnInputs */

const en_us2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taken on ${i?.date}`)
};

const pt_br2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feita em ${i?.date}`)
};

const es_419_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hecha el ${i?.date}`)
};

const pt_pt2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feita em ${i?.date}`)
};

const fr_fr2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prise le ${i?.date}`)
};

const de_de2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aufgenommen am ${i?.date}`)
};

const it_it2_body_assessment_taken_on = /** @type {(inputs: Body_Assessment_Taken_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fatta il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Taken on {date}" |
*
* @param {Body_Assessment_Taken_OnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_taken_on = /** @type {((inputs: Body_Assessment_Taken_OnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Taken_OnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_taken_on(inputs)
	if (locale === "es-419") return es_419_body_assessment_taken_on(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_taken_on(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_taken_on(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_taken_on(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_taken_on(inputs)
	return en_us2_body_assessment_taken_on(inputs)
});
export { body_assessment_taken_on as "body-assessment.taken_on" }